// Globally intercepts fetch responses so an expired/invalid token (401)
// anywhere in the app forces a clean logout instead of leaving the UI
// in a broken, half-authenticated state.
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  if (response.status === 401 && window.location.pathname !== "/") {
    localStorage.clear();
    window.location.href = "/";
    return response;
  }

  return response;
};
